var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.Constants.RUOLO, function (ruolo_id) {
      var _obj
      return _c(
        "v-btn",
        {
          key: ruolo_id,
          style: {
            opacity: _vm.disabledRuolo(ruolo_id) ? 0.2 : 1,
          },
          attrs: {
            disabled: _vm.disabledRuolo(ruolo_id),
            depressed: "",
            icon: "",
            large: "",
          },
          nativeOn: {
            click: function ($event) {
              return _vm.selectRuolo(ruolo_id)
            },
          },
        },
        [
          _c(
            "span",
            {
              staticClass: "Ruolo outline",
              class:
                ((_obj = {}),
                (_obj["Ruolo_" + ruolo_id] = true),
                (_obj.selezionato = _vm.selectedRuoloClassic == ruolo_id),
                _obj),
            },
            [_vm._v(_vm._s(_vm.ruolo(ruolo_id)))]
          ),
        ]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }